const unsafeRegexp = /[<>"'\r\n&]/g;
const unsafeSymbols: Record<string, string> = {
  "'": 'apos',
  '"': 'quot',
  '\r': '#10',
  '\n': '#13',
  '&': 'amp',
  '<': 'lt',
  '>': 'gt'
};

export function html(v: string) {
  return v.replace(unsafeRegexp, (c) => `&${unsafeSymbols[c]};`);
}
